// extracted by mini-css-extract-plugin
module.exports = {"Background":"InteractiveImageSkeleton_Background__bsmhl","Overflow":"InteractiveImageSkeleton_Overflow__2PMRa"};